import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const reorderPageSectionPdpSelector = createSelector(testTargetOffersSelector, offers => offers.reorderPageSectionPDP || Empty.Object);

export { reorderPageSectionPdpSelector };
